import _ from 'lodash'
import {getter} from 'util/BackboneCompatUtil';
import {castToSisTypePrimitive} from 'util/SisType';
import {DqParamTO, SisType} from 'generated/JavaTO'
import {CFMember, CFModel} from 'module/CustomField/type/CFType'
import {log} from 'common/log'
import {CFMemberComparator, getPosFromCFMember} from 'module/CustomField/util/CustomField'

function getDqParamFromModel(dqParam: DqParamTO, model: CFModel, currentPos?: number): string | number | undefined | null {
	if (!dqParam) return;
	let {srcName, startIndex, length, type, defaultValue} = dqParam
	let ret;
	if (_.startsWith(srcName, 'cf.')) {
		const cf = getter(model, 'cf') as CFMember[]
		if (!cf) return null
		const withoutCF = srcName.substring(3)
		const nextDotAt = withoutCF.indexOf('.')
		if (withoutCF.substring(nextDotAt + 1) === 'length') {
			// cf.dstField.length
			const cfName = withoutCF.substring(0, nextDotAt)
			ret = cf.filter(c => {
				if (c.dstField !== cfName) return false;
				const val = c.data || c.lat || c.lon || (c.lazy && c.preview)
				return val || val === 0
			}).length
		} else {
			// cf.dstField[x].data
			const splitResult = withoutCF.split(/\[([0-9]+|[x][+-]?[0-9]*)\]/)
			if (splitResult.length != 3) {
				log.error('dqparam dstField malformed:', dqParam)
				return null
			}
			const dstField = splitResult[0]
			const index = splitResult[1]
			const variableIndex = index[0] === 'x'
			const members = cf.filter(c => c.dstField === dstField)
			let member: CFMember | undefined;
			if (variableIndex) {
				let findPos = currentPos || 0
				const posModifier = variableIndex && +index.substring(1) || 0
				if (posModifier) {
					const positions = members.sort(CFMemberComparator).map(x => getPosFromCFMember(x))
					const posIndex = positions.indexOf(findPos)
					if (posIndex > -1) {
						const newPosIndex = posIndex + posModifier
						findPos = positions[newPosIndex]
					}
				}
				member = members.find(c => c.pos === findPos)
			} else {
				member = members.sort((a, b) => a.pos - b.pos)[parseInt(index)]
			}
			const attributeSelector = splitResult[2].substring(1)
			ret = attributeSelector ? _.get(member, attributeSelector) : member
			if (!ret && ret !== 0) ret = ''
		}
	} else {
		// dstField
		ret = getter(model, srcName)
		if (!ret && ret !== 0) ret = ''
		ret += ''
		ret = ret.substring(startIndex, length ? startIndex + length : undefined)
	}
	if (!ret && ret !== 0) {
		if (defaultValue != null) return castToSisTypePrimitive(defaultValue, type as SisType);
		return null
	} else {
		return castToSisTypePrimitive(ret, type as SisType);
	}
}

export function getDqParamsObject(dqParams: DqParamTO[] | undefined, model: any, currentPos?: number): Record<string, string | number | null | undefined> {
	return dqParams?.reduce((ret, p) => {
		ret[p.dstName] = getDqParamFromModel(p, model, currentPos);
		return ret
	}, {} as Record<string, any>) || {}
}


export function parseDqParamFromSerializedString(str: string): DqParamTO {
	const x = str.split('|')
	return {
		srcName: x[0],
		dstName: x[1],
		startIndex: parseInt(x[2]) || 0,
		length: parseInt(x[3]) || undefined,
		type: x[4] || ' ',
		defaultValue: x[5] || null,
	}
}